/*
 *  Copyright (c) 2011-2024 Acronis International GmbH. All rights reserved.
 *
 *  This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *  No portion of it may be redistributed or modified without the written permission of Acronis. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Utils')
    .directive('accFocus', ['$timeout', function ($timeout) {
        return {
            scope: {
                trigger: '=accFocus'
            },
            link: function ($scope, $element) {
                if (angular.isDefined($scope.trigger)) {
                    $scope.$watch('trigger', function (value) {
                        if (!value) return;

                        $element[0].focus();
                    })
                } else {
                    $timeout(function () {
                        $element[0].focus();
                    }, 50)
                }
            }
        }
    }]);
